import { LandingPageConfig } from 'rangeConfig/@types';
import platsaBgImage from '../../views/LandingPage/images/PLATSA_background.jpg';
import designFromScratch from '../../views/LandingPage/images/designFromScratch.jpg';
import platsaOpenDesignImg from '../../views/LandingPage/images/platsa_landing_open_design.jpg';
import platsaBrowseInspirationImg from '../../views/LandingPage/images/platsa_browse_inspiration.jpg';
import platsaGalleryConfig from './platsaGalleryConfig';

const platsaLandingPageConfig: LandingPageConfig = {
  rangeDesign: {
    backgroundImgUrl: platsaBgImage,
    titleTextColor: '#FFFFFF'
  },
  designFromScratch: {
    backgroundColor: '#CED9EA',
    backgroundImgUrl: designFromScratch
  },
  openDesign: {
    backgroundColor: '#F5F5F5',
    backgroundImgUrl: platsaOpenDesignImg
  },
  browseInspiration: {
    backgroundColor: '#CCD9EC',
    backgroundImgUrl: platsaBrowseInspirationImg,
    galleryConfig: platsaGalleryConfig
  }
};

export default platsaLandingPageConfig;
